const INSTRUCTIONS_TYPES = {
  video_resource: 1,
  html: 2,
};

export default {
  INSTRUCTIONS_TYPES,
  INSTRUCTIONS_TYPES_ICONS: {
    [INSTRUCTIONS_TYPES.video_resource]: 'mdi-video',
    [INSTRUCTIONS_TYPES.html]: 'mdi-image-text',
  },
};
